module.exports = __webpack_public_path__ + "static/media/constructionSite-it.c18005a6.jpeg";